export interface Category {
  id: number
  name: string
  color: string
  slug: string
}

// Mapa de categorías para acceso O(1)
export const CATEGORIES_MAP = {
  politica: { id: 1, name: 'Política', color: 'blue', slug: 'politica' },
  sociedad: { id: 2, name: 'Sociedad', color: 'green', slug: 'sociedad' },
  tecnologia: { id: 3, name: 'Tecnología', color: 'purple', slug: 'tecnologia' },
  cultura: { id: 4, name: 'Cultura', color: 'orange', slug: 'cultura' },
  salud: { id: 5, name: 'Salud', color: 'red', slug: 'salud' }
} as const

export const categories = Object.values(CATEGORIES_MAP)

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return CATEGORIES_MAP[slug as keyof typeof CATEGORIES_MAP]
}

export const getCategoryName = (id: number): string => {
  return categories.find(cat => cat.id === id)?.name || 'Sin categoría'
}

export const getCategoryslug = (id: number): string => {
  return categories.find(cat => cat.id === id)?.slug || ''
}

export const getCategoryColor = (id: number): string => {
  return categories.find(cat => cat.id === id)?.color || 'gray'
} 